export default __webpack_public_path__ + "static/media/exo.fccdec4e.svg";